import DataStore from "../../../stores/DataStore";

export const AvisoImportante = "IMPORTANTE: Esta simulação calcula os valores conforme as informações preenchidas, podendo variar conforme a execução efetiva dos serviços. Esta simulação não é garantia dos valores incorridos no terminal, uma vez que a carga poderá sofrer serviços não listados previamente pelo cliente."
export default class SimulacaoServicosStore extends DataStore {

    dadosModalidade = this.defaultObj({});

    constructor() {
        super();

    };
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/stores/SimulacaoServicosStore.js